import { SEVER_DATE_TIME_FORMAT } from "library/helpers/utils";
import dayjs from "dayjs";
import { isUndefined } from "lodash";

export const STATUS_TYPES = [
  { id: 1, status: "All" },
  { id: 2, status: "Success" },
  { id: 3, status: "Failed" },
  { id: 4, status: "Resolved" },
  { id: 5, status: "Inqueue" },
];

export const DASHBOARD_TABS = {
  ORDER: "1",
  INVOICE: "2",
  POD: "3",
  INVALID: "4"
};

export const POD_STATUS_TYPES = [
  { id: 1, status: "All" },
  { id: 2, status: "Success" },
  { id: 3, status: "Failed" },
];

interface CustomerOption {
  id: string;
  name: string;
  code: string;
  label: string;
  value: string;
}
export const initialPagination = {
  current: 1,
  pageSize: 10,
  total: 0,
};

export const getDateRangeFromOption = (option: any) => {
  let startDate = null;
  let endDate: any = dayjs();

  switch (option) {
    case "today":
      startDate = dayjs();
      break;
    case "last7days":
      startDate = dayjs().subtract(6, "day");
      break;
    case "thisMonth":
      startDate = dayjs().startOf("month");
      break;
    case "lastMonth":
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
      break;
    case "custom":
      startDate = null;
      endDate = null;
      break;
  }

  return { startDate, endDate };
};

const getBillToValue = (
  customerValue: string | undefined | null | CustomerOption,
  userBillTo: [],
) => {
  const filteredBillTo = userBillTo?.map((item: any) => item.name);
  if (
    customerValue &&
    typeof customerValue === "object" &&
    "value" in customerValue
  ) {
    return customerValue.value.toString().toUpperCase()?.includes("ALL")
      ? filteredBillTo?.join(",")
      : customerValue?.toString().toUpperCase();
  }
  const upperCustomer =
    customerValue?.toString().toUpperCase()?.includes("ALL") ||
    isUndefined(customerValue)
      ? filteredBillTo?.join(",")
      : customerValue?.toString().toUpperCase();
  return upperCustomer;
};

export const buildActivityPayload = (
  filterParams: {
    status: string;
    sortField: any;
    sortOrder: any;
    searchValue: any;
    dateRange: string;
    startDate: { format: (arg0: string) => any };
    endDate: { format: (arg0: string) => any };
    customer: any;
    date: any;
  },
  pagination: { current: any; pageSize: any },
  userDetails: { customers: any; vendors: any },
  isInvalid: boolean,
  searchValue: string,
  from: "activity" | "invoice" | "pod",
) => {
  return {
    pageNumber: pagination.current,
    pageSize: pagination.pageSize,
    sortColumn:
      filterParams.sortField ||
      (from === "pod" ? "processedDate" : "receivedOn"),
    sortOrder: filterParams.sortOrder || "DESC",
    searchValue: searchValue || "",
    dateRangeType: filterParams.dateRange?.toUpperCase?.() ?? "CUSTOM",
    startDate: filterParams.startDate?.format?.(SEVER_DATE_TIME_FORMAT) ?? null,
    endDate: filterParams.endDate?.format?.(SEVER_DATE_TIME_FORMAT) ?? null,
    date: filterParams.date ?? null,
    ...(!isInvalid && {
      ...(from === "pod"
        ? { podStatus: filterParams.status?.toUpperCase?.() ?? "ALL" }
        : { activityStatus: filterParams.status.toUpperCase() }),
      billTo:
        from === "invoice"
          ? getBillToValue(filterParams.customer, userDetails?.vendors)
          : getBillToValue(filterParams.customer, userDetails?.customers),
    }),
  };
};